import React from 'react';
import './assets/scss/themes.scss';
import RouteIndex from 'Routes/Index';
import '@fortawesome/fontawesome-free/css/all.min.css';
// import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
//fakeBackend();

function App() {
  return <RouteIndex />;
}

export default App;